import type React from "react";

export interface SidebarItem {
  label: string;
  path: string;
  icon: React.ReactNode;
  section?: string;
  badge?: {
    label: string;
    color: string;
  };
}

/** True when `pathname` is the item's route or nested beneath it. */
export function isNavItemActive(pathname: string, itemPath: string) {
  const base = itemPath.replace(/\/$/, "");
  if (!base) return pathname === "/";
  return pathname === base || pathname.startsWith(base + "/");
}

export function groupNavItems(items: SidebarItem[]) {
  return items.reduce(
    (acc, item) => {
      const section = item.section || "General";
      (acc[section] ??= []).push(item);
      return acc;
    },
    {} as Record<string, SidebarItem[]>,
  );
}

/** Section names arrive in any case ("MY PLACEMENTS"); show them in sentence case. */
export function sectionLabel(section: string) {
  const lower = section.trim().toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

/** The deepest sidebar item that matches the current path, for breadcrumbs. */
export function activeNavItem(items: SidebarItem[], pathname: string) {
  return items
    .filter((item) => isNavItemActive(pathname, item.path))
    .sort((a, b) => b.path.length - a.path.length)[0];
}

export function rolePaths(role?: string) {
  if (role === "student") {
    return { notifications: "/student/notifications", profile: "/student/profile" };
  }
  if (role === "partner") {
    return { notifications: "/partner/notifications", profile: "/partner/profile" };
  }
  return { notifications: "/admin/notifications", profile: "/admin/settings" };
}

export function initials(name?: string | null) {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "U";
  return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
}
